export enum REQUEST_STATUS {
    OPEN_REQUEST_STATUS = 1,
    INPROGRESS_REQUEST_STATUS = 2,
    RETURNED_REQUEST_STATUS = 3,
    CLOSED_REQUEST_STATUS = 4,
    SECURITY_COORDINATOR_REQUESTS = 5,
    EMPLOYEE_MANAGEMENT_REQUESTS = 6,
    OPERATION_OPEN_REQUEST_STATUS = 5,
    OPERATION_INPROGRESS_REQUEST_STATUS = 6,
    OPERATION_COMPLETED_REQUEST_STATUS = 7,
    OPERATION_COMPLETED_HISTORY_REQUESTS = 8,
    OPERATION_TECHNICAL_REQUESTS_STATUS = '',
    OPERATION_DASHBOARD_REQUESTS_STATUS = 9,
}
